import React, { useEffect, useState } from "react";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";

export default function MessageCard({ index, item, reload, userType }) {
  const [loading, setLoading] = useState(false);
  const [backend, setBackend] = useState(null);
  const [tpassword, setTpassword] = useState("");

  const [openClearModal, setOpenClearModal] = useState(false);

  // Initialize backend once
  useEffect(() => {
    const initBackend = async () => {
      try {
        const backendInstance = await new Backend().init();
        setBackend(backendInstance);
      } catch (err) {
        console.error("Backend init failed:", err);
        toast.error("Failed to initialize backend");
      }
    };
    initBackend();
  }, []);

  const handleDelete = async () => {
    if (!backend) {
      toast.error("Backend not ready yet");
      return;
    }
    if (!tpassword) {
      toast.error("Please enter transaction password");
      return;
    }

    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        message_id: item.id,
      };

      const res = await backend.delete_message(data);
      if (res?.error === "False") {
        toast.success(res.message);
        reload?.();
      } else {
        toast.error(res?.message || "Delete failed");
      }
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("Error deleting message");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="RulesContainer">
        <div className="RulesExchange">
          {index.index + 1}. {item.msg}
        </div>

        {userType === 1 && (
          <button
            onClick={() => (!loading ? setOpenClearModal(true) : undefined)}
            disabled={loading}
            className="px-4 py-1.5 bg-[var(--sell)] text-white rounded-full text-sm font-semibold shadow"
          >
            {loading ? "DELETING..." : "DELETE"}
          </button>
        )}
      </div>

      {/* 🔥 CLEAR MODAL */}
      {openClearModal && (
        <div
          className="customModalOverlay"
          onClick={() => setOpenClearModal(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Delete Message</h3>
            <p className="customModalWarning">
              This action will delete messgae data for server.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setOpenClearModal(false)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                className="dropbtnNavSub white primary"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? "Clearing..." : "Confirm Clear"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
